module.exports = __webpack_public_path__ + "static/media/ic_standing.3b16f8fb.svg";